import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    component: () => import("@/views/login/login"),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import("@/views/index"),
    children: [
      {
        path: '/',
        component: () => import("@/views/home/index"),
        meta: { title: '首页' , bgColor: '#F1F2F4',bgPadding:'0'},
      },
      // 消息通知
      {
        path: '/msgNotice',
        component: () => import("@/views/msgNotice/index"),
        meta: { title: '消息' },
      },
      //投放管理
      {
        path: '/partners',
        component: () => import("@/views/lockManage/partners/index"),
        meta: { title: '合作机构管理' },
      },
      {
        path: '/lockBatch',
        component: () => import("@/views/lockManage/lockBatch/index"),
        meta: { title: '投放批次' },
      },
      {
        path: '/lockRegion',
        component: () => import("@/views/lockManage/lockRegion/index"),
        meta: { title: '投放区域' },
      },
      {
        path: '/servePlace',
        component: () => import("@/views/lockManage/servePlace/index"),
        meta: { title: '服务场所' },
      },
      {
        path: '/roomManage',
        component: () => import("@/views/lockManage/servePlace/roomManage"),
        meta: { title: '房间管理' },
      },
      {
        path: '/addLockPosition',
        component: () => import("@/views/lockManage/addLockPosition/index"),
        meta: { title: '新增锁位' },
      },
      {
        path: '/lockQuery',
        component: () => import("@/views/lockManage/lockQuery/index"),
        meta: { title: '投放查询' },
      },
      //用户管理
      {
        path: '/registerInfo',
        component: () => import("@/views/userManage/registerInfo/index"),
        meta: { title: '用户注册信息' },
      },
      {
        path: '/smsTemplate',
        component: () => import("@/views/userManage/smsTemplate/index"),
        meta: { title: '短信模板' },
      },
      {
        path: '/smsSendSituation',
        component: () => import("@/views/userManage/smsSendSituation/index"),
        meta: { title: '短信发送情况' },
      },
      {
        path: '/userLoginSituation',
        component: () => import("@/views/userManage/userLoginSituation/index"),
        meta: { title: '用户登录情况' },
      },
      {
        path: '/codeInfo',
        component: () => import("@/views/userManage/codeInfo/index"),
        meta: { title: '验证码信息' },
      },
      {
        path: '/couponGrant',
        component: () => import("@/views/userManage/couponGrant/index"),
        meta: { title: '优惠券发放' },
      },
      {
        path: '/userAnalysis',
        component: () => import("@/views/userManage/userAnalysis/index"),
        meta: { title: '用户分析' },
      },
      //运营监测
      {
        path: '/lowBattery',
        component: () => import("@/views/monitor/lowBattery/index"),
        meta: { title: '低电量预警' },
      },
      {
        path: '/lockFailLog',
        component: () => import("@/views/monitor/lockFailLog/index"),
        meta: { title: '用锁失败记录' },
      },
      {
        path: '/sendTimeout',
        component: () => import("@/views/monitor/sendTimeout/index"),
        meta: { title: '寄存超长' },
      },
      {
        path: '/idleQuery',
        component: () => import("@/views/monitor/idleQuery/index"),
        meta: { title: '闲置查询' },
      },
      // 运营管理
      {
        path: '/operationPerson',
        component: () => import("@/views/operationManage/operationPerson/index"),
        meta: { title: '运营人员' },
      },
      {
        path: '/transportationPerson',
        component: () => import("@/views/operationManage/transportationPerson/index"),
        meta: { title: '站内运力人员' },
      },
      {
        path: '/opPermit',
        component: () => import("@/views/operationManage/opPermit/index"),
        meta: { title: '运营权限管理' },
      },
      {
        path: '/sendQuery',
        component: () => import("@/views/operationManage/sendQuery/index"),
        meta: { title: '锁运营查询' },
      },
      {
        path: '/sendQueryList',
        component: () => import("@/views/operationManage/sendQuery/detailList"),
        meta: { title: '锁运营查询列表' },
      },
      {
        path: '/sendHistory',
        component: () => import("@/views/operationManage/sendHistory/index"),
        meta: { title: '锁历史查询' },
      },
      {
        path: '/sendHistoryList',
        component: () => import("@/views/operationManage/sendHistory/detailList"),
        meta: { title: '锁历史查询列表' },
      },
      {
        path: '/deliverQuery',
        component: () => import("@/views/operationManage/deliverQuery/index"),
        meta: { title: '递送业务查询' },
      },
      {
        path: '/deliverQueryList',
        component: () => import("@/views/operationManage/deliverQuery/detailList"),
        meta: { title: '递送业务查询列表' },
      },
      {
        path: '/deliverHistory',
        component: () => import("@/views/operationManage/deliverHistory/index"),
        meta: { title: '历史递送查询' },
      },
      {
        path: '/deliverHistoryList',
        component: () => import("@/views/operationManage/deliverHistory/detailList"),
        meta: { title: '历史递送查询列表' },
      },
      // {
      //   path: '/operationAnalysis',
      //   component: () => import("@/views/operationManage/operationAnalysis/index"),
      //   meta: { title: '运营分析' },
      // },
      // 运维管理
      {
        path: '/opMaintenancePerson',
        component: () => import("@/views/opMaintenanceManage/opMaintenancePerson/index"),
        meta: { title: '运维人员' },
      },
      {
        path: '/opMPermit',
        component: () => import("@/views/opMaintenanceManage/opMPermit/index"),
        meta: { title: '运维权限管理' },
      },
      {
        path: '/lockRepair',
        component: () => import("@/views/opMaintenanceManage/lockRepair/index"),
        meta: { title: '锁报损/修处理' },
      },
      {
        path: '/complain',
        component: () => import("@/views/opMaintenanceManage/complain/index"),
        meta: { title: '投诉建议' },
      },
      // 系统设置
      {
        path: '/cityInfo',
        component: () => import("@/views/systemSet/cityInfo/index"),
        meta: { title: '城市信息' },
      },
      {
        path: '/sendRule',
        component: () => import("@/views/systemSet/sendRule/index"),
        meta: { title: '寄存计费规则' },
      },
      {
        path: '/deliverRule',
        component: () => import("@/views/systemSet/deliverRule/index"),
        meta: { title: '递送计费规则' },
      },
      {
        path: '/deliverAddress',
        component: () => import("@/views/systemSet/deliverAddress/index"),
        meta: { title: '递送地址管理' },
      },
      {
        path: '/menuSet',
        component: () => import("@/views/systemSet/menuSet/index"),
        meta: { title: '菜单设置' },
      },
      {
        path: '/versionSet',
        component: () => import("@/views/systemSet/versionSet/index"),
        meta: { title: '版本设置' },
      },
      {
        path: '/partnersSet',
        component: () => import("@/views/systemSet/partnersSet/index"),
        meta: { title: '机构设置' },
      },
      // 财务管理
      {
        path: '/Invoicing',
        component: () => import("@/views/financeManage/Invoicing/index"),
        meta: { title: '开票处理' },
      },
      {
        path: '/refund',
        component: () => import("@/views/financeManage/refund/index"),
        meta: { title: '退款处理' },
      },
      // 出厂验证
      {
        path: '/importLockInfo',
        component: () => import("@/views/factoryCheck/importLockInfo/index"),
        meta: { title: '导入锁信息' },
      },
      {
        path: '/inportSellLock',
        component: () => import("@/views/factoryCheck/inportSellLock/index"),
        meta: { title: '导入出货锁' },
      },
      //测试管理
      {
        path: '/testPerson',
        component: () => import("@/views/testManage/testPerson/index"),
        meta: { title: '测试人员' },
      },
      //所所管理
      {
        path: '/suosuoPerson',
        component: () => import("@/views/suosuoManage/suosuoPerson/index"),
        meta: { title: '所所人员' },
      },
      {
        path: '/suosuoPermit',
        component: () => import("@/views/suosuoManage/suosuoPermit/index"),
        meta: { title: '所所人员权限' },
      },
    ]
  },

]

const router = new VueRouter({
  mode: "hash",
  routes
})
// 解决登录失效跳回登录页时的报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
// 首页样式
router.beforeEach((to, from, next) => {  
  if (to.meta.bgColor) {  
    document.documentElement.style.setProperty('--content-bg-color', to.meta.bgColor);  
    document.documentElement.style.setProperty('--content-bg-padding', to.meta.bgPadding);  
  }else{
    document.documentElement.style.setProperty('--content-bg-color','#ffffff');  
    document.documentElement.style.setProperty('--content-bg-padding', '16px');  
  } 
  next();  
});
export default router
